module.exports = __webpack_public_path__ + "media/images/icons/flags/HR-13a36422c8a07e20c8ed7eb25063a70f.svg";